import {
  IconButton,
  Menu,
  MenuItem,
  VeBox,
  VeTypography,
} from "@packages/ui/mui";
import { COMBO_CHART, VIEW_QUILT } from "@public/index";
import Image from "next/image";
import { useRouter } from "next/navigation";
import React, { useState } from "react";
import { openOrFocusTab } from "@libs/helper";
import AppsIcon from "@components/SvgComponents/AppsIcon";
import { StatusTag } from "@packages/ui/components";
import { userPermissionCheck } from "@libs/customHooks/permissionCheck/UserPermissionCheck";

const AppDropdown = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const router = useRouter();
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const creditAnalytics = userPermissionCheck(
    "credit-analytics.global-carbon-projects.read"
  );
  const creditAnalyticsComingSoon = userPermissionCheck(
    "credit-analytics.global-carbon-projects.coming-soon"
  );
  // Define menu items - you can customize these based on your needs
  const menuItems = [
    {
      label: "My Projects",
      subtext: "Access and manage all organisation level projects",
      icon: COMBO_CHART,
      onClick: () => {
        openOrFocusTab("/apps/all-projects", "vericap-all-projects");
        handleClose();
      },
    },
    ...(creditAnalytics
      ? [
          {
            label: "Credit Analytics",
            subtext: "Get insights and analytics on the credits market",
            icon: VIEW_QUILT,
            comingSoon: creditAnalyticsComingSoon,
            onClick: () => {
              openOrFocusTab(
                "/apps/analytics/carbon/overview",
                "vericap-credit-analytics"
              );
              handleClose();
            },
          },
        ]
      : []),
  ];

  return (
    <div>
      <IconButton
        onClick={handleClick}
        sx={{
          backgroundColor: anchorEl ? "#EFE9FB" : "transparent",
          border: anchorEl ? "1px solid #703DDE" : "1px solid transparent",
          borderRadius: anchorEl ? "50%" : "none",
          padding: "4px",
          "&:hover": { backgroundColor: "#E8E8E8" },
        }}
      >
        <AppsIcon active={Boolean(anchorEl)} />
      </IconButton>

      <Menu
        id="app-dropdown-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        MenuListProps={{
          disablePadding: true,
        }}
        slotProps={{
          paper: {
            sx: {
              border: "1px solid #E8E8E8",
              borderRadius: "8px",
              padding: "16px 8px 8px 8px",
              minWidth: "400px",
              boxShadow:
                "0px 2px 16px 0px rgba(0, 0, 0, 0.08), 0px 2px 8px -2px rgba(0, 0, 0, 0.12)",
              mt: "8px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            },
          },
        }}
      >
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            onClick={!item?.comingSoon ? item.onClick : undefined}
            sx={{
              borderRadius: "4px",
              padding: "8px 12px",
              "&:hover": {
                backgroundColor: !item?.comingSoon ? "#F3F3F3" : "transparent",
                cursor: !item?.comingSoon ? "pointer" : "not-allowed",
              },
            }}
          >
            <VeBox
              display="flex"
              flexDirection="row"
              gap="8px"
              alignItems="center"
            >
              <VeBox
                sx={{
                  padding: "5px",
                  background: "#E8E8E8",
                  borderRadius: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image src={item?.icon} alt={item.label} />
              </VeBox>
              <VeBox display="flex" flexDirection="column" gap="4px">
                <VeBox
                  display="flex"
                  flexDirection="row"
                  gap="8px"
                  alignItems={"center"}
                >
                  <VeTypography variant="label2Main">{item.label}</VeTypography>
                  {item.comingSoon && (
                    <StatusTag
                      bullet={false}
                      status="blueTag"
                      noBorder
                      color="#3D465A"
                      sx={{ backgroundColor: "#F3F3F3" }}
                    >
                      Coming Soon{" "}
                    </StatusTag>
                  )}
                </VeBox>
                <VeTypography variant="label3Secondary">
                  {item.subtext}
                </VeTypography>
              </VeBox>
            </VeBox>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default AppDropdown;
